export const INVENTORY_CABANG_GET_REQUEST = "INVENTORY_CABANG_GET_REQUEST";
export const INVENTORY_CABANG_GET_SUCCESS = "INVENTORY_CABANG_GET_SUCCESS";
export const INVENTORY_CABANG_GET_FAIL = "INVENTORY_CABANG_GET_FAIL";
export const INVENTORY_CABANG_GET_RESET = "INVENTORY_CABANG_GET_RESET";
